var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"b1 bc7 p4 bg5 r2"},[(_vm.component_)?[(_vm.plan_)?_c(_vm.component_,_vm._b({tag:"component",on:{"premium:updated":function($event){return _vm.$emit('premium:updated')}}},'component',{
					productId: _vm.productId,
					caseId: _vm.$store.state.caseManagement.caseId,
					proposalId: _vm.$store.state.caseManagement.proposalId,
					offerId: _vm.$store.state.caseManagement.offerId
				},false)):_vm._e()]:_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }